<template>
  <Multiselect
    :value="value"
    :label="label"
    :placeholder="placeholder"
    :multiple="true"
    :searchable="true"
    :disabled="disabled"
    :search-change-callback="suggestAsync"
    :get-label-callback="getLabel"
    @input="$emit('input', $event)"
  />
</template>

<script>
import httpClient from '@/utils/httpClient';
import Multiselect from '@/components/common/Multiselect';

export default {
  components: { Multiselect },
  props: {
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Search for people or teams'
    },
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  data() {
    return {
      debounceTimer: null
    };
  },
  methods: {
    getLabel(value) {
      return value;
    },
    suggestAsync(q) {
      return new Promise(resolve => {
        clearTimeout(this.debounceTimer);
        if (!q || !q.length) {
          resolve([]);
          return;
        }
        this.debounceTimer = setTimeout(async () => {
          const [users, teams] = await Promise.all([
            httpClient.get(`/api/auth/suggest/users?q=${encodeURIComponent(q)}`).catch(() => []),
            httpClient.get(`/api/auth/teams`).catch(() => [])
          ]);

          const matchingTeams = (Array.isArray(teams) ? teams : teams?.data ?? [])
            .filter(t => t.name && t.name.toLowerCase().includes(q.toLowerCase()))
            .map(t => t.name);

          const userEmails = Array.isArray(users) ? users : [];

          resolve([...new Set([...userEmails, ...matchingTeams])]);
        }, 200);
      });
    }
  }
};
</script>
